import { DonateIcon } from "@atos6/icons"
import { RaiseText } from "../raise-components"
import React from "react"
import { Header, HeaderLeft, HeaderRight, SwitchDonateStyled } from "../App.styles"

export function Head() {
  return (
    <Header>
      <HeaderLeft>
        <DonateIcon />
        <RaiseText textAlign="center" marginLeft="24px" fontWeight="600" color="#262626">
          Configure a doação online
        </RaiseText>
      </HeaderLeft>
      <HeaderRight>
        <SwitchDonateStyled />
      </HeaderRight>
    </Header>
  )
}
